import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading, Modal, SystemText } from 'e4shared';
import { apiGet } from 'services';
import { e4Format } from 'helpers/dates';
import BlobImage from 'components/blobImage';

export const TeamNotRated = ({ profile }) => {
    const [data, setData] = useState([]);
    const [profileShow, setProfileShow] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    const st = (path, ...rest) => SystemText(`User121/e4Metrics/Details/TeamNotRated/Popup/${path}`, ...rest);

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        Boolean(profile) && apiGet(`team-not-rated/${profile.id}`, guid, response => gotResponse(response));
    }, [guid, profile.id]);

    const showRow = id => (profileShow.indexOf(id) >= 0 ? '' : 'hidden');
    const staffIcon = id => (profileShow.indexOf(id) >= 0 ? 'minus' : 'plus');
    const toggleStaff = id => {
        const value = profileShow.indexOf(id) >= 0 ? profileShow.filter(x => x !== id) : profileShow.concat([id]);
        setProfileShow(value);
    };

    let people = data.reduce((c, d) => (c.some(x => x.profile_Id === d.profile_Id) ? c : c.concat([d])), []);

    return loading ? (
        <Loading />
    ) : (
        <div>
            {people.map(p => {
                const competencies = data.filter(d => d.profile_Id === p.profile_Id);
                return (
                    <div key={`profile-${p.profile_Id}`}>
                        <div className="mb5 flex flex-center">
                            <i
                                onClick={() => toggleStaff(p.profile_Id)}
                                className={`pointer fa fa-${staffIcon(p.profile_Id)}-square mr5`}
                            />
                            <BlobImage
                                height="20"
                                className="img-circle mr5"
                                src={p.avatar}
                                folder="avatar"
                                initials={p.initials}
                            />
                            <span className="mr5">
                                <Link
                                    title={st('Table/Rated/Popup/Link/Title', p.full_Name)}
                                    to={`/develop/performance-dashboard/${p.profile_Id}`}
                                >
                                    {p.full_Name}
                                </Link>
                            </span>
                            <span>({`${competencies.length} unrated`})</span>
                        </div>
                        <div className={`${showRow(p.profile_Id)} ml50 mb5`}>
                            {competencies.map(c => (
                                <div key={`competency-${c.profile_Id}-${c.competency_Id}`}>
                                    {c.area} - {c.competency}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TeamNotRated;
